<app-offcanvas-base [returnUrl]="returnUrl()">
  <ng-container title>
    <app-offcanvas-header-btn
      title="Replace {{ isEmployeeCard() ? 'virtual' : 'subscription' }} card"></app-offcanvas-header-btn>
  </ng-container>
  <ng-container body>
    @if (cardDetails) {
      <div class="text-center mt-5 mb-5">
        <img
          ngSrc="../../../../../assets/graphics/man-card.svg"
          alt=""
          width="180"
          height="122" />
      </div>
      <div class="h4">
        Are you sure you want to remove and replace
        @if (isEmployeeCard()) {
          {{ cardDetails.holder.first_name }} {{ cardDetails.holder.last_name }}'s card
        } @else {
          "{{ cardDetails.name }}"
        }
        ?
      </div>
      <p class="text-muted">The cardholder will get notified that they have been issued a new card.</p>
      <div class="row gy-3 offcanvas-buttons">
        <div class="col-12 col-sm-auto">
          <button
            type="button"
            (click)="close()"
            class="btn btn-outline-dark">
            Cancel
          </button>
        </div>
        <div class="col-12 col-sm-auto ms-sm-auto">
          <button
            class="btn btn-primary align-self-end"
            (click)="onReplaceCard()">
            Yes, replace card
          </button>
        </div>
      </div>
    }
  </ng-container>
</app-offcanvas-base>
